import { createSelector, defaultMemoize } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const memoized = defaultMemoize((lastUpdated, categories, entities) =>
  categories.length ? entities.categories : [],
);

export const categoryListSelector = createSelector(
  [propertiesSelector],
  ({ categories = [], entities, lastUpdated }) => memoized(lastUpdated, categories, entities),
);

export const linearChannelsCategoryListSelector = subselect(categoryListSelector);
